import React from 'react';
import Input from 'components/Fields/Input';
import TextArea from 'components/Fields/TextArea';

export const Text = ({ name, label, placeholder, long, required }) => (
  long
    ? (
      <TextArea
        errorMessages={required ? { required: { message: 'Veuillez indiquer une réponse' } } : undefined}
        label={label}
        model={`.${name}`}
        rows={5}
        placeholder={placeholder}
      />
    )
    : (
      <Input
        errorMessages={required ? { required: { message: 'Veuillez indiquer une réponse' } } : undefined}
        label={label}
        model={`.${name}`}
        placeholder={placeholder}
      />
    )
);

export default Text;



// WEBPACK FOOTER //
// ./src/components/Form/FormActivity/Controls/ControlText.js